import React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import moment from 'moment';
import styled, { useTheme } from 'styled-components';

import AppState from '@webapp/store/state';
import { ListReleasesSummary } from '@webapp/store/release/action-creators';

import { Category } from '@common/types/categories/category';
import { ReleaseStore } from '@common/types/release/release-store';

import StoreDropdownList from '../takedown-submit/store-dropdown-list';

import Box from '@components/layout/box';
import { getWidth } from '@components/styles';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';
import Flex from '@components/layout/flex';
import { Translate } from 'react-localize-redux';
import Grid from '@components/basics/grid';
interface TakedownSuccessProps {
  releaseTitle: string;
  className?: string;
  activeStore: ReleaseStore[];
  stores: Category<ReleaseStore>[];
  isNFT?: boolean;
  getReleaseSummary: () => any;
  push: (path: string) => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  stores: state.categories.lists['platform'] || [],
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  push: (path: string) => dispatch(push(path)),
  getReleaseSummary: () => dispatch(new ListReleasesSummary()),
});

const TakedownSuccess = ({
  releaseTitle,
  className,
  push,
  stores,
  isNFT,
  activeStore,
  getReleaseSummary,
}: TakedownSuccessProps) => {
  React.useEffect(() => {
    getReleaseSummary();
  }, [getReleaseSummary]);
  const theme = useTheme();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      push('/catalog');
    }, 5000);
    return () => clearTimeout(timer);
  }, [push]);

  return (
    <MotionOpacity className={className}>
      <CorrectProfileWrapper>
        <Box>
          <Grid gap={20}>
            <Flex justifyContent="space-between" alignItems="center" gap={10}>
              <CompletedIcon size={32} />
              <Typography
                type="small"
                align="right"
                color={theme.colors.tertiary}
              >
                {moment(new Date()).format('DD MMM YYYY')}
              </Typography>
            </Flex>
            <Grid gap={15}>
              <Typography type="subheader" customFont="semi-bold">
                <Translate
                  id={
                    isNFT
                      ? 'CATALOG.TAKEDOWN.SUCCESS.TITLE.NFT'
                      : activeStore.length === stores.length
                      ? 'CATALOG.TAKEDOWN.SUCCESS.TITLE.ALL'
                      : 'CATALOG.TAKEDOWN.SUCCESS.TITLE.NUMBER'
                  }
                  data={{
                    releaseName: releaseTitle,
                    amount: activeStore.length,
                  }}
                />
              </Typography>
              <Typography type="small" color={theme.colors.tertiary}>
                <Translate
                  id={
                    isNFT
                      ? 'CATALOG.TAKEDOWN.SUCCESS.TEXT.NFT'
                      : 'CATALOG.TAKEDOWN.SUCCESS.TEXT'
                  }
                />
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <LinkWrapper justifyContent="space-between" alignItems="center">
          <Typography uppercase weight="700">
            <Translate id="CATALOG.TAKEDOWN.SUCCESS.REDIRECT" />
          </Typography>
          <Link align="right" onClick={() => push('/catalog')}>
            <Translate id="CATALOG.TAKEDOWN.SUCCESS.LINK" />
          </Link>
        </LinkWrapper>

        {!isNFT && (
          <StoreDropdownList
            stores={stores.map((store) => store.metadata)}
            activeStore={activeStore}
          />
        )}
      </CorrectProfileWrapper>
    </MotionOpacity>
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(TakedownSuccess)`
  margin-top: 80px;
`);

const CorrectProfileWrapper = styled.div`
  min-height: 100vh;
  padding-inline: 24px;
  max-width: ${getWidth(10)};
  margin-inline: auto;

  @media ${({ theme }) => theme.device.laptopS} {
    width: auto;
    padding-inline: 0;
  }

  .title-header {
    margin-bottom: 20px;
  }
`;

const Link = styled(Typography)`
  cursor: pointer;
  text-decoration-line: underline;
  transition: color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;

const LinkWrapper = styled(Flex)`
  margin: 40px auto 80px;
`;
